// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 11604-公告新增 POST /web/v1/notice/add */
export async function addSwimNotice(
  body: API.SwimNoticeBasicVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOString>("/web/v1/notice/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 11606-公告删除 GET /web/v1/notice/delete/${param0} */
export async function deleteSwimNotice(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteSwimNoticeParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOString>(`/web/v1/notice/delete/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 11603-公告详情查询 GET /web/v1/notice/detail/${param0} */
export async function getSwimNoticeDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSwimNoticeDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimNoticeBasicVo>(
    `/web/v1/notice/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 11601-公告列表查询 GET /web/v1/notice/list */
export async function getSwimNoticeList(options?: { [key: string]: any }) {
  return request<API.YmResultVOListSwimNoticeBasicVo>("/web/v1/notice/list", {
    method: "GET",
    ...(options || {}),
  });
}

/** 11602-分页查询公告列表 POST /web/v1/notice/pageList */
export async function getSwimNoticePageList(
  body: API.SwimNoticePageQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimNoticeBasicVo>(
    "/web/v1/notice/pageList",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 11607-公告状态变更 POST /web/v1/notice/status/${param0} */
export async function updateSwimNoticeStatus(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.updateSwimNoticeStatusParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOString>(`/web/v1/notice/status/${param0}`, {
    method: "POST",
    params: {
      ...queryParams,
    },
    ...(options || {}),
  });
}

/** 11605-公告修改 POST /web/v1/notice/update */
export async function updateSwimNotice(
  body: API.SwimNoticeBasicVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOString>("/web/v1/notice/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
